import React, { Profiler, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import {
  round,
  reverse,
  replace,
  gt,
  compact,
  map,
  some,
  isUndefined,
  filter,
  size,
  last,
  gte,
  eq,
  isNumber,
  join,
  startCase,
  camelCase,
  truncate,
  toLower,
  unescape,
  includes,
  find,
} from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Footer, StatusBar, Ring, Nav, Tree } from '.';
import { ui, uiA, uiFormRow, uiCheckbox, uiBadge } from 'envy-ui';
import { useLocation } from 'react-router-dom';
import { useMutation, useQuery } from '@apollo/client';
import $ from 'jquery';
import FroalaEditorView from 'react-froala-wysiwyg/FroalaEditorView';
import ga4 from 'react-ga4';
import moment from 'moment';
import ReactGA from 'react-ga';
import ReactTooltip from 'react-tooltip';
import { MenuConsumer } from './menu';
import { PAGE_VIEW } from '../../graphqls';
import Header from './header';
import Measure from './measure';
import MeasurePage from './measurePage';
import onRender from '../../util/onRender';
import removeHtml from '../../util/remove_html_markup';

export default function DrillDownPage({
  isPublic,
  data = {},
  data: {
    numberWithLabel = '',
    metricType,
    highChartSetting,
    handsontable,
    embed,
    measureId,
    children,
    measures,
    latestUpdate,
    description,
    onTrack,
    majorDisruption,
    minorDisruption,
    upcoming,
    discontinued,
    completed,
    statusPending,
    planNodeId,
    progress,
    parentPlanNodeId,
    additionalText,
    additionalBottomText,
    additionalMiddleText,
    additionalUpperMiddleText,
    title,
    visualTitle,
    checklist,
    tags: tagIds,
    customFieldRecords,
    startDate,
    endDate,
  } = {},
  settings = {},
  settings: {
    rootLevel,
    startOfFinancialYear,
    showStatusBar,
    showProgress,
    showIndicatorOnHeader,
    drilldownable,
    enableDrillDown,
    childrenDescriptionLabel,
    childrenStatusLabel,
    cssOverwrite,
    logo: { image: logo } = {},
    logoLink,
    fontFamily,
    horizontalPadding,
    fontSize,
    footer,
    footerBackgroundColor,
    headerBackgroundColor,
    banner: { image: banner, position: backgroundPosition } = {},
    navTextColor = 'rgba(255, 255, 255, 1)',
    showMeasureDetail,
    googleTranslate,
    name: corporationName,
    showChecklist,
    googleTracking,
    tags,
    customFields,
    showTags,
    showCustomFields,
    hideTags,
    displayLowestLevelDates,
  } = {},
  linkPrefix,
  ancestor = [],
  branding,
  navs,
  name,
  planName,
}) {
  const showLatestUpdate = data.showLatestUpdate && settings.showLatestUpdate && latestUpdate;
  const siChildren = filter(children, 'enable');
  const siMeasures = filter(measures, 'enable');
  const displayLevel = { 1: 1, 2: 2, 3: 3, 4: 4, 5: 5, ONE: 1, TWO: 2, THREE: 3, FOUR: 4, FIVE: 5 }[settings.displayLevel];
  const navPosition = toLower(settings.navPosition);
  const measureColumns = { 1: 1, 2: 2, 3: 3, ONE: 1, TWO: 2, THREE: 3 }[settings.measureColumns];
  const popover = { position: 'fixed', zIndex: '11', top: '0', height: '100%', overflow: 'auto', backgroundColor: '#f7f7f7' };
  const cover = { position: 'fixed', top: '0px', right: '0px', bottom: '0px', left: '0px' };
  let visualTitleStyles = {};

  // const rootLevel = min(compact(map(pageList, 'numberWithLabel')).map((n) => last(n.split(' ')).split('.').length));
  const currentLevel = last(numberWithLabel.split(' ')).split('.').length - (rootLevel - 1);

  if (includes(['Highcharts', 'Handsontable', 'Embed'], metricType)) {
    let jsonString = embed;

    if (eq(metricType, 'Highcharts')) {
      jsonString = highChartSetting;
    } else if (eq(metricType, 'Handsontable')) {
      jsonString = handsontable;
    }

    const { title: { font_size: visualTitleFontSize, color: visualTitleColor } = {} } = JSON.parse(jsonString);

    visualTitleStyles = {
      fontSize: visualTitleFontSize,
      color: visualTitleColor,
    };
  }

  $(window).scroll(() => {
    if (eq($(window).scrollTop(), 0)) {
      $('.header-inner').removeClass('sticky-header').css('background-color', 'transparent');
      $('.header').removeClass('sticky-header');
    } else {
      $('.header-inner').addClass('sticky-header').css('background-color', headerBackgroundColor);
      $('.header').addClass('sticky-header');
    }
  });

  let layout;

  if (measureId) {
    layout = (
      <MeasurePage data={data} startOfFinancialYear={startOfFinancialYear || moment.utc().format()} showMeasureDetail={showMeasureDetail} />
    );
  } else {
    const quantitativeMeasures = map(siMeasures, (measure) => (
      <Measure
        measureData={measure}
        key={measure.measureId}
        linkPrefix={linkPrefix}
        startOfFinancialYear={startOfFinancialYear || moment.utc().format()}
        columns={measureColumns}
      />
    ));
    const lastUpdateSection =
      showLatestUpdate && !!latestUpdate ? (
        <section className="latest-update-container">
          <strong className="latest-update-label">Latest Update:</strong>
          <div className="update-container">
            <span className="pd-custom fr-view">
              <FroalaEditorView model={latestUpdate} />
            </span>
          </div>
        </section>
      ) : (
        ''
      );
    let quantitativeChildren;
    let childrenNodeTable;
    const currentNodeInfo = (
      <section className="drilldown-upper-info">
        <div
          style={{ fontSize: `${parseInt(fontSize, 10) + 1}px` }}
          className={`first-row-description pd-custom fr-view ${!showStatusBar ? 'progress-only-description' : ''}`}
        >
          <FroalaEditorView model={description} />
        </div>

        {isNumber(progress) && showProgress ? (
          <div className="drilldown-upper-ring">
            <Ring
              width={35}
              percent={progress}
              text={`${round(progress)}%`}
              borderWidth={3}
              fontSize={9}
              borderColor="#1594c9"
              backgroundColor="transparent"
            />
          </div>
        ) : (
          ''
        )}
        {showStatusBar &&
        some([onTrack, majorDisruption, minorDisruption, upcoming, discontinued, completed, statusPending], (status) => gt(status, 0)) ? (
          <div className="drilldown-upper-status">
            <div className="status">
              <StatusBar
                onTrack={onTrack}
                majorDisruption={majorDisruption}
                minorDisruption={minorDisruption}
                upcoming={upcoming}
                discontinued={discontinued}
                completed={completed}
                statusPending={statusPending}
                settings={settings}
                keyPrefix={planNodeId}
              />
            </div>
          </div>
        ) : (
          ''
        )}
      </section>
    );

    if (gt(size(siChildren), 0) && displayLevel > currentLevel) {
      const showProgressInScope = some(siChildren, (child) => isNumber(child.progress));
      const showStatusBarInScope = some(
        siChildren,
        (child) =>
          child.onTrack ||
          child.discontinued ||
          child.upcoming ||
          child.majorDisruption ||
          child.minorDisruption ||
          child.statusPending ||
          child.completed,
      );

      const descriptionClassArray = ['description description-sub'];

      if (showProgress && showProgressInScope && (!showStatusBar || !showStatusBarInScope)) {
        descriptionClassArray.push('description-progress');
      }

      if (showStatusBar && showStatusBarInScope && (!showProgress || !showProgressInScope)) {
        descriptionClassArray.push('description-status-bar');
      }

      if ((!showProgress || !showProgressInScope) && (!showStatusBar || !showStatusBarInScope)) {
        descriptionClassArray.push('description-only');
      }

      const descriptionClassName = join(descriptionClassArray, ' ');

      quantitativeChildren = map(
        siChildren,
        ({
          progress: childProgress,
          description: childDescription,
          onTrack: childOnTrack,
          majorDisruption: childMajorDisruption,
          minorDisruption: childMinorDisruption,
          upcoming: childUpcoming,
          discontinued: childDiscontinued,
          completed: childCompleted,
          statusPending: childStatusPending,
          planNodeId: childPlanNodeId,
        }) => {
          let progressRing;

          if (showProgress && showProgressInScope) {
            if (isNumber(childProgress)) {
              progressRing = (
                <Ring
                  width={35}
                  percent={childProgress}
                  text={`${round(childProgress)}%`}
                  borderWidth={3}
                  fontSize={9}
                  borderColor="#1594c9"
                  backgroundColor="transparent"
                  isCell
                />
              );
            } else {
              progressRing = <div className="progress-ring-container" role="cell" />;
            }
          }

          let linkable = true;
          const currentDepth = size(ancestor) + 1;

          if (!isUndefined(enableDrillDown)) {
            if (enableDrillDown) {
              if (eq(size(ancestor), 1)) {
                linkable = false;
              }
            } else {
              linkable = false;
            }
          } else if (displayLevel === currentDepth) {
            if (drilldownable) {
              linkable = false;
            }
          } else if (displayLevel - 1 === currentDepth) {
            if (!drilldownable) {
              linkable = false;
            }
          }

          return (
            <div className="child-node-row" key={childPlanNodeId}>
              <Link
                to={`${linkPrefix}/${childPlanNodeId}`}
                onClick={
                  linkable
                    ? undefined
                    : (e) => {
                        e.preventDefault();
                      }
                }
                aria-label={truncate(removeHtml(childDescription), { separator: ' ', length: 60 })} // A11y change
                className={linkable ? 'child-link' : 'nolink'}
                role="row"
              >
                <div className={descriptionClassName} role="cell">
                  <span className="pd-custom fr-view">
                    <FroalaEditorView model={childDescription} />
                  </span>
                </div>
                {progressRing}
                {showStatusBar ? (
                  <StatusBar
                    onTrack={childOnTrack}
                    majorDisruption={childMajorDisruption}
                    minorDisruption={childMinorDisruption}
                    upcoming={childUpcoming}
                    discontinued={childDiscontinued}
                    completed={childCompleted}
                    statusPending={childStatusPending}
                    settings={settings}
                    keyPrefix={childPlanNodeId}
                    isCell
                  />
                ) : (
                  ''
                )}
              </Link>
            </div>
          );
        },
      );

      if (gte(displayLevel, currentLevel) || enableDrillDown || parentPlanNodeId === '') {
        childrenNodeTable = (
          <section className="child-node-table-wrapper">
            {size(siChildren) > 0 && (
              <div className="child-node-table" role="table">
                <div role="rowgroup">
                  <div className="child-node-row table-label" role="row">
                    <div className={descriptionClassName} role="columnheader">
                      {removeHtml(childrenDescriptionLabel)}
                    </div>
                    {showProgress && showProgressInScope && (
                      <div className="progress-ring-container" role="columnheader">
                        Progress
                      </div>
                    )}
                    {showStatusBar && showStatusBarInScope && (
                      <div className="status-bar" role="columnheader">
                        {childrenStatusLabel}
                      </div>
                    )}
                  </div>
                </div>
                <div role="rowgroup">{quantitativeChildren}</div>
              </div>
            )}
          </section>
        );
      }
    }

    layout = (
      <div className="drilldown-layout">
        {!!additionalText && (
          <article className="pd-custom fr-view">
            <FroalaEditorView model={additionalText} />
          </article>
        )}
        {currentNodeInfo}
        {!!displayLowestLevelDates && !!planNodeId && planNodeId?.includes('Activity') && !measureId && (
          <article {...ui([uiA`m-bottom`])}>
            <div {...ui([uiFormRow`--baseline`, uiA`f-gap-large`])}>
              <div {...ui([uiFormRow`__label --long`])}>Start Date</div>
              <div>{moment(startDate).isValid() ? moment(startDate).format('ll') : 'Ongoing'}</div>
            </div>
            <div {...ui([uiFormRow`--baseline`, uiA`f-gap-large`])}>
              <div {...ui([uiFormRow`__label --long`])}>End Date</div>
              <div>{moment(endDate).isValid() ? moment(endDate).format('ll') : 'Ongoing'}</div>
            </div>
          </article>
        )}
        {showCustomFields && customFields?.length && customFieldRecords?.length ? (
          <section {...ui([uiA`w-100%`])}>
            {customFields.map(
              ({
                fieldName,
                fieldType = '',
                numberDecimalRounding,
                numberPrefix,
                numberSuffix,
                numberThousandSeparator,
                customFieldId,
              }) => {
                const { id: recordId, checkBoxChecked, content, picklistItems } = find(customFieldRecords, { customFieldId }) || {};

                if (recordId) {
                  switch (fieldType.toUpperCase()) {
                    case 'MULTI_SELECT_PICKLIST':
                      return (
                        <div key={`drill-down-page-custom-field-record-${recordId}`} {...ui([uiFormRow`--baseline`, uiA`f-gap-large`])}>
                          <div {...ui([uiFormRow`__label --long`])}>{fieldName}</div>
                          <div>{content.split('\n').join(', ')}</div>
                        </div>
                      );
                    case 'CHECK_BOX':
                      return (
                        <div key={`drill-down-page-custom-field-record-${recordId}`} {...ui([uiFormRow`--baseline`, uiA`f-gap-large`])}>
                          <div {...ui([uiFormRow`__label --long`])}>{fieldName}</div>
                          <div
                            role="checkbox"
                            aria-readonly
                            aria-checked={checkBoxChecked}
                            tabIndex={0}
                            {...ui([uiCheckbox`--check --checked:${checkBoxChecked}`, uiA`cursor-off top-3`])}
                          ></div>
                        </div>
                      );
                    case 'NUMBER':
                      switch (numberThousandSeparator) {
                        case 'COMMA_DOT':
                          return (
                            <div key={`drill-down-page-custom-field-record-${recordId}`} {...ui([uiFormRow`--baseline`, uiA`f-gap-large`])}>
                              <div {...ui([uiFormRow`__label --long`])}>{fieldName}</div>
                              <div>{`${numberPrefix}${Number(content).toLocaleString('en-CA')}${numberSuffix}`}</div>
                            </div>
                          );
                        default:
                          return (
                            <div key={`drill-down-page-custom-field-record-${recordId}`} {...ui([uiFormRow`--baseline`, uiA`f-gap-large`])}>
                              <div {...ui([uiFormRow`__label --long`])}>{fieldName}</div>
                              <div>{`${numberPrefix}${content}${numberSuffix}`}</div>
                            </div>
                          );
                      }
                    case 'RICH_TEXT':
                      return (
                        <div key={`drill-down-page-custom-field-record-${recordId}`} {...ui([uiFormRow`--baseline`, uiA`f-gap-large`])}>
                          <div {...ui([uiFormRow`__label --long`])}>{fieldName}</div>
                          <div>
                            <FroalaEditorView model={content} />
                          </div>
                        </div>
                      );
                    default:
                      return (
                        <div key={`drill-down-page-custom-field-record-${recordId}`} {...ui([uiFormRow`--baseline`, uiA`f-gap-large`])}>
                          <div {...ui([uiFormRow`__label --long`])}>{fieldName}</div>
                          <div>{content}</div>
                        </div>
                      );
                  }
                } else {
                  return '';
                }
              },
            )}
          </section>
        ) : (
          ''
        )}
        {showChecklist && checklist && JSON.parse(checklist).length ? (
          <div className="latest-update-container">
            <strong className="latest-update-label">Checklist:</strong>
            {JSON.parse(checklist)?.map(({ id: itemId, checked: itemChecked, content: itemContent }) => (
              <label key={`checklist-item${itemId}`} className="latest-update-checklist">
                <input type="checkbox" disabled checked={itemChecked} />
                {itemContent}
                {/* {itemWeight} */}
              </label>
            ))}
          </div>
        ) : (
          ''
        )}
        {!!showIndicatorOnHeader && childrenNodeTable}
        {lastUpdateSection}
        {!!additionalUpperMiddleText && (
          <article className="pd-custom fr-view">
            <FroalaEditorView model={additionalUpperMiddleText} />
          </article>
        )}
        {siMeasures.length > 0 && <section className="measures-container quantitative-measures-container">{quantitativeMeasures}</section>}
        {!!additionalMiddleText && (
          <article className="pd-custom fr-view">
            <FroalaEditorView model={additionalMiddleText} />
          </article>
        )}
        {!showIndicatorOnHeader && childrenNodeTable}
        {!!additionalBottomText && (
          <article className="pd-custom fr-view">
            <FroalaEditorView model={additionalBottomText} />
          </article>
        )}
      </div>
    );
  }

  const parents = map(reverse(JSON.parse(JSON.stringify(ancestor))), ({ title: ancestorTitle, planNodeId: ancestorPlanNodeId }) => (
    <li key={ancestorPlanNodeId} className={['page', ancestorPlanNodeId].join('-')}>
      <Link to={`${linkPrefix}/${ancestorPlanNodeId}`} className={['link', ancestorPlanNodeId].join('-')}>
        {removeHtml(ancestorTitle)}
      </Link>
    </li>
  ));
  const { pathname: page } = useLocation();
  const [onPageView] = useMutation(PAGE_VIEW);

  useEffect(() => {
    if (isPublic) {
      try {
        const eventCategory = [name, planName].join(' - ');

        onPageView({
          variables: { pathname: page },
          onCompleted() {
            ga4.initialize(googleTracking.filter((trackingId) => trackingId.indexOf('G-') === 0).map((trackingId) => ({ trackingId })));
            ga4.event({ category: eventCategory, action: 'impression', label: title });
            googleTracking
              .filter((trackingId) => trackingId.indexOf('UA-') === 0)
              .forEach((trackingId) => {
                ReactGA.initialize(trackingId);
                ReactGA.set({ page });
                ReactGA.pageview(page);
              });
          },
        });
      } catch (e) {
        console.error(e);
      }
    }
  }, [page]);

  // if (loading) {
  //   return '';
  // }

  return (
    <Profiler id="DrillDownPage" onRender={onRender}>
      <title>{settings?.pageTitle || title}</title>
      <style dangerouslySetInnerHTML={{ __html: cssOverwrite }} />
      <MenuConsumer>
        {({ toggleMenu, showMenu }) => (
          <div className="page-wrapper">
            <div className="page drilldown" style={{ fontFamily: `${startCase(camelCase(fontFamily))}`, fontSize: parseInt(fontSize, 10) }}>
              {eq(navPosition, 'left') && showMenu ? (
                <div style={popover} className="popover-extra-style">
                  <div tabIndex={-1} style={cover} onClick={toggleMenu} onKeyPress={() => {}} role="button" />
                  <button onClick={toggleMenu} type="button" className="menu-close-btn">
                    <FontAwesomeIcon icon={['fal', 'times']} />
                  </button>
                  <Tree items={navs} linkPrefix={linkPrefix} />
                </div>
              ) : (
                ''
              )}
              {eq(navPosition, 'top') && showMenu && gt(size(navs), 0) ? (
                <div className="top-responsive-menu popover-extra-style" style={popover}>
                  <div tabIndex={-1} style={cover} onClick={toggleMenu} onKeyPress={() => {}} role="button" />
                  <button onClick={toggleMenu} type="button" className="menu-close-btn">
                    <FontAwesomeIcon icon={['fal', 'times']} />
                  </button>
                  <Nav items={navs} linkPrefix={linkPrefix} navTextColor="rgba(0,125,165,1)" />
                </div>
              ) : (
                ''
              )}
              <a href="#main" className="skip-link" aria-label="Skip to main content">
                Skip To Main Content
              </a>
              {branding && (
                <Header
                  logo={logo}
                  logoLink={logoLink}
                  linkPrefix={linkPrefix}
                  backgroundColor={headerBackgroundColor}
                  backgroundImage={banner}
                  backgroundPosition={backgroundPosition}
                  navs={navs}
                  displayLevel={displayLevel}
                  navTextColor={navTextColor}
                  navPosition={navPosition}
                  googleTranslate={googleTranslate}
                  corporationName={corporationName}
                />
              )}
              <main
                className="drilldown-container"
                id="main"
                style={{
                  paddingLeft: horizontalPadding.indexOf('%') > 0 ? `${(100 - Number(horizontalPadding.split('%')[0])) / 2}%` : undefined,
                  paddingRight: horizontalPadding.indexOf('%') > 0 ? `${(100 - Number(horizontalPadding.split('%')[0])) / 2}%` : undefined,
                  maxWidth: horizontalPadding.indexOf('px') > 0 ? horizontalPadding : undefined,
                }}
              >
                <ul className="breadcrumb" aria-label="Breadcrumb">
                  <li className={join(['page', 'home'], '-')}>
                    <Link to={`${linkPrefix}/`} className="link-home" aria-label="Homepage" data-for="home-icon" data-tip="Home">
                      <FontAwesomeIcon icon={['fal', 'home']} />
                    </Link>
                    <ReactTooltip id="home-icon" />
                  </li>
                  {parents}
                  <li className={join(['page', measureId || planNodeId], '-')} aria-current="page">
                    {removeHtml(title)}
                  </li>
                </ul>
                {!!measureId && !!visualTitle && (
                  <span
                    className="visual-title"
                    style={visualTitleStyles}
                    role="heading"
                    aria-level={2}
                    aria-label={`Visual title: ${visualTitle}`}
                  >
                    {visualTitle}
                  </span>
                )}
                {showTags && compact(tagIds).length ? (
                  <article {...ui([uiA`f f-wrap f-gap-small w-100% m-bottom-small`])}>
                    {compact(tagIds).map((tagId) => {
                      if (hideTags.includes(tagId)) {
                        return '';
                      }

                      return (
                        <span
                          key={`drill-down-page-tag-${tagId}`}
                          {...ui([uiBadge`--tag`])}
                          style={{ color: find(tags, { tagId })?.colorCode }}
                        >
                          <span {...ui([uiA`color-default`])}>{find(tags, { tagId })?.tagName}</span>
                        </span>
                      );
                    })}
                  </article>
                ) : (
                  ''
                )}
                {layout}
              </main>
            </div>
            {branding && (
              <Footer
                content={footer}
                backgroundColor={footerBackgroundColor || 'rgba(255,255,255,0)'}
                fontFamily={`${startCase(camelCase(fontFamily))}`}
                corporationName={corporationName}
              />
            )}
          </div>
        )}
      </MenuConsumer>
    </Profiler>
  );
}

DrillDownPage.propTypes = {
  data: PropTypes.shape({
    numberWithLabel: PropTypes.string,
    metricType: PropTypes.string,
    handsontable: PropTypes.string,
    embed: PropTypes.string,
    highChartSetting: PropTypes.string,
    measureId: PropTypes.string,
    children: PropTypes.arrayOf(
      PropTypes.shape({
        onTrack: PropTypes.number,
        discontinued: PropTypes.number,
        upcoming: PropTypes.number,
        majorDisruption: PropTypes.number,
        minorDisruption: PropTypes.number,
        statusPending: PropTypes.number,
        completed: PropTypes.number,
        progress: PropTypes.number,
        description: PropTypes.string,
        planNodeId: PropTypes.string,
      }),
    ),
    measures: PropTypes.arrayOf(PropTypes.shape({ measureId: PropTypes.string })),
    latestUpdate: PropTypes.string,
    description: PropTypes.string,
    onTrack: PropTypes.number,
    majorDisruption: PropTypes.number,
    minorDisruption: PropTypes.number,
    upcoming: PropTypes.number,
    discontinued: PropTypes.number,
    completed: PropTypes.number,
    statusPending: PropTypes.number,
    planNodeId: PropTypes.string,
    progress: PropTypes.number,
    parentPlanNodeId: PropTypes.string,
    additionalText: PropTypes.string,
    additionalBottomText: PropTypes.string,
    additionalMiddleText: PropTypes.string,
    additionalUpperMiddleText: PropTypes.string,
    title: PropTypes.string,
    visualTitle: PropTypes.string,
  }).isRequired,
  ancestor: PropTypes.arrayOf(PropTypes.shape({ title: PropTypes.string, planNodeId: PropTypes.string })),
  linkPrefix: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]).isRequired,
  branding: PropTypes.bool.isRequired,
  settings: PropTypes.shape({
    startOfFinancialYear: PropTypes.string,
    showStatusBar: PropTypes.bool,
    showProgress: PropTypes.bool,
    showIndicatorOnHeader: PropTypes.bool,
    drilldownable: PropTypes.bool,
    enableDrillDown: PropTypes.bool,
    childrenDescriptionLabel: PropTypes.string,
    childrenStatusLabel: PropTypes.string,
    cssOverwrite: PropTypes.string,
    logo: PropTypes.shape({ image: PropTypes.string }),
    logoLink: PropTypes.string,
    fontFamily: PropTypes.string,
    horizontalPadding: PropTypes.string,
    fontSize: PropTypes.string,
    footer: PropTypes.string,
    footerBackgroundColor: PropTypes.string,
    headerBackgroundColor: PropTypes.string,
    banner: PropTypes.shape({ image: PropTypes.string, position: PropTypes.string }),
    navTextColor: PropTypes.string,
  }).isRequired,
  navs: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};
